import { render, staticRenderFns } from "./RunningPriceV2.vue?vue&type=template&id=6e99f5c8&scoped=true&"
import script from "./RunningPriceV2.vue?vue&type=script&lang=js&"
export * from "./RunningPriceV2.vue?vue&type=script&lang=js&"
import style0 from "./RunningPriceV2.vue?vue&type=style&index=0&id=6e99f5c8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e99f5c8",
  null
  
)

export default component.exports